import "../../CommonImports";
import "../../Core/core.css";
import "./Tabs.css";
import * as React from "react";
import { Pill, PillSize } from '../../Pill';
import { Tooltip } from '../../TooltipEx';
import { css } from '../../Util';
export const TabBadge = props => {
    const { children, className, containsCount = true, tooltipProps } = props;
    let badge = (React.createElement(Pill, { className: css(className, "bolt-tab-badge"), containsCount: containsCount, size: PillSize.compact, contentClassName: "text-ellipsis", excludeFocusZone: true, excludeTabStop: true }, children));
    if (tooltipProps) {
        badge = React.createElement(Tooltip, Object.assign({}, tooltipProps), badge);
    }
    return badge;
};
